import React from 'react';
import Table from 'components/ui/Table';
import TextField from 'components/ui/TextField';
import Switch from '@mui/material/Switch';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

interface AvailabilityDay {
    id: number;
    day: string;
    isActive: boolean;
    duration: number;
    startTime: string;
    endTime: string;
}

interface LocationAvailabilityTableProps {
    availability: AvailabilityDay[];
    onAvailabilityChange: (newAvailability: AvailabilityDay[]) => void;
}

const LocationAvailabilityTable: React.FC<LocationAvailabilityTableProps> = ({
                                                                                 availability,
                                                                                 onAvailabilityChange
                                                                             }) => {
    const handleToggle = (id: number) => {
        const newAvailability = availability.map(day =>
            day.id === id ? {...day, isActive: !day.isActive} : day
        );
        onAvailabilityChange(newAvailability);
    };

    const handleInputChange = (id: number, field: keyof AvailabilityDay, value: string | number) => {
        const newAvailability = availability.map(day =>
            day.id === id ? {...day, [field]: value} : day
        );
        onAvailabilityChange(newAvailability);
    };

    const handleCopy = (rowToCopy: AvailabilityDay) => {
        const newAvailability = availability.map(day => ({
            ...day,
            isActive: rowToCopy.isActive,
            duration: rowToCopy.duration,
            startTime: rowToCopy.startTime,
            endTime: rowToCopy.endTime
        }));
        onAvailabilityChange(newAvailability);
    };

    const columns = [
        {field: 'status', headerName: 'Status', width: 100},
        {field: 'day', headerName: 'Days', width: 120},
        {field: 'startTime', headerName: 'Working Time Start', width: 250},
        {field: 'endTime', headerName: 'Working Time End', width: 250},
        {field: 'actions', headerName: '', width: 100},
        {field: 'Total Minutes', headerName: 'Total Minutes Per Day', width: 250},
    ];

    const renderRow = (row: AvailabilityDay, index: number) => (
        <TableRow key={row.id}>
            <TableCell>
                <Switch
                    checked={row.isActive}
                    onChange={() => handleToggle(row.id)}
                    color="primary"
                />
            </TableCell>
            <TableCell>{row.day}</TableCell>
            <TableCell>
                <TextField
                    id="startTime"
                    type="time"
                    value={row.startTime}
                    onChange={(e) => handleInputChange(row.id, 'startTime', e.target.value)}
                    disabled={!row.isActive}
                    fullWidth
                />
            </TableCell>
            <TableCell>
                <TextField
                    id="endTime"
                    type="time"
                    value={row.endTime}
                    onChange={(e) => handleInputChange(row.id, 'endTime', e.target.value)}
                    disabled={!row.isActive}
                    fullWidth
                />
            </TableCell>
            <TableCell>
                <IconButton aria-label="copy" onClick={() => handleCopy(row)}>
                    <ContentCopyIcon/>
                </IconButton>
            </TableCell>
            <TableCell>
                <div>{determineMinutesPerDay(row)}</div>
            </TableCell>
        </TableRow>
    );

    const determineMinutesPerDay = (row: { startTime: string; endTime: string; isActive: boolean }) => {
        if (!row.isActive) return "0";

        console.log(row.startTime)
        console.log(row.endTime)
        // Parse start and end times
        const start = new Date(`1970-01-01T${row.startTime}:00`);
        const end = new Date(`1970-01-01T${row.endTime}:00`);

        // Calculate the difference in milliseconds and convert to minutes
        const diffInMs = end.getTime() - start.getTime();
        const minutes = Math.floor(diffInMs / 60000);

        return minutes.toString();
    };

    return (
        <Table
            columns={columns}
            rows={availability}
            renderRow={renderRow}
            showPagination={false}
        />
    );
};

export default LocationAvailabilityTable;
